var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-tab',{attrs:{"tabs":_vm.tabsHorizontal,"type":"horizontal"}})}
var staticRenderFns = []

export { render, staticRenderFns }